var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNogatewayLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.27 75.0199L51.85 69.6899C52.63 68.8699 53.17 67.7199 51.58 66.7999L27.91 53.1299L27.83 53.0799C25.58 51.7899 22.78 52.1699 20.52 53.4699C18.26 54.7699 17.42 56.4899 19.65 57.8099L43.46 71.5199C43.46 71.5199 45.78 72.5699 48.82 71.5399L58.18 76.8199C58.18 76.8199 59.41 77.3799 60.86 76.5399C60.86 76.5399 62.35 75.6499 61.27 75.0199Z",
    fill: "url(#paint0_linear_2317_204489)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.61 44.7901C52.61 36.0601 46.48 25.4501 38.93 21.0901C35.11 18.8901 31.66 18.7001 29.18 20.1801L22.63 23.9701L25.26 28.6601C25.26 28.7701 25.26 28.8801 25.26 28.9901C25.26 37.5801 31.2 47.9901 38.6 52.4701L41.54 57.7301L48.56 53.6801C51.07 52.2601 52.62 49.1901 52.62 44.7901H52.61Z",
    fill: "url(#paint1_linear_2317_204489)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6951 57.6406C47.0377 54.5561 47.037 44.553 41.6936 35.298C36.3503 26.0431 27.6877 21.0409 22.3451 24.1254C17.0026 27.21 17.0033 37.2131 22.3466 46.468C27.69 55.723 36.3526 60.7251 41.6951 57.6406Z",
    fill: "url(#paint2_linear_2317_204489)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6651 55.8568C45.4385 53.1009 45.4375 44.1629 40.663 35.8932C35.8885 27.6236 28.1485 23.1538 23.3751 25.9097C18.6018 28.6656 18.6027 37.6036 23.3772 45.8732C28.1517 54.1429 35.8917 58.6127 40.6651 55.8568Z",
    fill: "#EDECED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.76 57.6001L41.63 57.6701C41.63 57.6701 41.72 57.6201 41.76 57.6001Z",
    fill: "#9D9D9D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.45 55.9101C38.37 56.5801 35.75 56.1801 32.91 54.5401C26.12 50.6201 20.61 41.0801 20.61 33.2401C20.61 29.7301 21.72 27.1501 23.55 25.7301C23.62 25.6801 23.69 25.6201 23.76 25.5701C23.68 25.6101 23.61 25.6501 23.53 25.6801C21.16 26.9001 19.67 29.7101 19.67 33.7701C19.67 41.6101 25.18 51.1501 31.97 55.0701C35.29 56.9901 38.3 57.2001 40.51 56.0101C40.72 55.9001 40.92 55.7701 41.12 55.6401C40.9 55.7401 40.68 55.8201 40.45 55.9001V55.9101Z",
    fill: "url(#paint3_linear_2317_204489)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.91 54.5501C26.12 50.6301 20.61 41.0901 20.61 33.2501C20.61 29.7401 21.72 27.1601 23.55 25.7401C23.62 25.6901 23.69 25.6301 23.76 25.5801C23.68 25.6201 23.61 25.6601 23.53 25.6901C21.16 26.9101 19.67 29.7201 19.67 33.7801C19.67 41.6201 25.18 51.1601 31.97 55.0801C35.29 57.0001 38.3 57.2101 40.51 56.0201C40.72 55.9101 40.92 55.7801 41.12 55.6501C40.9 55.7501 40.68 55.8301 40.45 55.9101C38.37 56.5801 35.75 56.1801 32.91 54.5401V54.5501Z",
    fill: "url(#paint4_linear_2317_204489)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5099 33.9801C45.3299 33.9301 45.1299 33.8101 44.9599 33.6201C44.6399 33.2701 44.5499 32.8301 44.7599 32.6401L58.9399 24.3801C59.1499 24.1901 59.5799 24.3201 59.8999 24.6801C60.2199 25.0301 60.3099 25.4701 60.0999 25.6601L45.9199 33.9201C45.8199 34.0101 45.6799 34.0301 45.5199 33.9801H45.5099Z",
    fill: "#D6D6D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.15 50.2599C48.2 50.0799 48.33 49.8799 48.52 49.7099C48.88 49.3999 49.32 49.3199 49.51 49.5299L58.07 60.0099C58.26 60.2199 58.11 60.6499 57.75 60.9599C57.39 61.2699 56.95 61.3499 56.76 61.1399L48.2 50.6599C48.11 50.5599 48.1 50.4099 48.14 50.2499L48.15 50.2599Z",
    fill: "#D6D6D6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M30.56 21.28C30.46 21.44 30.28 21.59 30.05 21.7C29.62 21.9 29.17 21.85 29.05 21.59L21.83 6.38996C21.71 6.12996 21.97 5.75996 22.4 5.56996C22.83 5.36996 23.28 5.41996 23.4 5.67996L30.62 20.88C30.67 21 30.65 21.14 30.56 21.28Z",
    fill: "#D6D6D6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M61.65 62.6499C61.65 60.2099 59.94 57.2399 57.82 56.0199C56.75 55.3999 55.79 55.3499 55.09 55.7599L53.26 56.8199L53.99 58.1299C53.99 58.1299 53.99 58.1899 53.99 58.2199C53.99 60.6199 55.65 63.5299 57.72 64.7899L58.54 66.2599L60.5 65.1299C61.2 64.7299 61.64 63.8699 61.64 62.6399L61.65 62.6499Z",
    fill: "url(#paint5_linear_2317_204489)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6008 66.2391C60.093 65.3775 60.0917 62.5815 58.5978 59.9939C57.1038 57.4063 54.683 56.0071 53.1908 56.8687C51.6985 57.7303 51.6998 60.5263 53.1938 63.1139C54.6877 65.7015 57.1085 67.1007 58.6008 66.2391Z",
    fill: "url(#paint6_linear_2317_204489)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3334 65.749C59.6747 64.9684 59.6698 62.4588 58.3224 60.1438C56.975 57.8288 54.7954 56.5849 53.4541 57.3656C52.1128 58.1462 52.1178 60.6558 53.4652 62.9708C54.8125 65.2858 56.9921 66.5297 58.3334 65.749Z",
    fill: "#EDECED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.27 65.74C57.69 65.93 56.96 65.82 56.16 65.36C54.26 64.27 52.72 61.61 52.72 59.42C52.72 58.44 53.03 57.72 53.54 57.33C53.56 57.32 53.58 57.3 53.6 57.29C53.58 57.29 53.56 57.31 53.54 57.32C52.88 57.66 52.46 58.44 52.46 59.58C52.46 61.77 54 64.43 55.9 65.52C56.83 66.05 57.67 66.11 58.29 65.78C58.35 65.75 58.41 65.71 58.46 65.68C58.4 65.71 58.34 65.73 58.27 65.75V65.74Z",
    fill: "url(#paint7_linear_2317_204489)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M56.16 65.36C54.26 64.27 52.72 61.61 52.72 59.42C52.72 58.44 53.03 57.72 53.54 57.33C53.56 57.32 53.58 57.3 53.6 57.29C53.58 57.29 53.56 57.31 53.54 57.32C52.88 57.66 52.46 58.44 52.46 59.58C52.46 61.77 54 64.43 55.9 65.52C56.83 66.05 57.67 66.11 58.29 65.78C58.35 65.75 58.41 65.71 58.46 65.68C58.4 65.71 58.34 65.73 58.27 65.75C57.69 65.94 56.96 65.83 56.16 65.37V65.36Z",
    fill: "url(#paint8_linear_2317_204489)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.65 11.74C29.65 9.3 27.94 6.33001 25.82 5.11001C24.75 4.49001 23.79 4.44001 23.09 4.85001L21.26 5.91001L21.99 7.22001C21.99 7.22001 21.99 7.28001 21.99 7.31001C21.99 9.71001 23.65 12.62 25.72 13.88L26.54 15.35L28.5 14.22C29.2 13.82 29.64 12.96 29.64 11.73L29.65 11.74Z",
    fill: "url(#paint9_linear_2317_204489)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5943 15.3248C28.0866 14.4632 28.0852 11.6672 26.5913 9.0796C25.0974 6.49204 22.6766 5.09284 21.1843 5.9544C19.692 6.81597 19.6934 9.61204 21.1873 12.1996C22.6812 14.7872 25.102 16.1864 26.5943 15.3248Z",
    fill: "url(#paint10_linear_2317_204489)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3143 14.8398C27.6535 14.0666 27.6535 11.5593 26.3142 9.23958C24.9749 6.91986 22.8035 5.66616 21.4643 6.43936C20.1251 7.21255 20.1251 9.71986 21.4644 12.0396C22.8037 14.3593 24.9751 15.613 26.3143 14.8398Z",
    fill: "#EDECED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.26 14.8299C25.68 15.0199 24.95 14.9099 24.16 14.4499C22.27 13.3599 20.73 10.6999 20.73 8.50988C20.73 7.52988 21.04 6.80988 21.55 6.41988C21.57 6.40988 21.59 6.38988 21.61 6.37988C21.59 6.37988 21.57 6.39988 21.55 6.40988C20.89 6.74988 20.47 7.52988 20.47 8.66988C20.47 10.8599 22.01 13.5199 23.9 14.6099C24.83 15.1399 25.67 15.1999 26.28 14.8699C26.34 14.8399 26.4 14.7999 26.45 14.7699C26.39 14.7999 26.33 14.8199 26.26 14.8399V14.8299Z",
    fill: "url(#paint11_linear_2317_204489)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.16 14.4499C22.27 13.3599 20.73 10.6999 20.73 8.50988C20.73 7.52988 21.04 6.80988 21.55 6.41988C21.57 6.40988 21.59 6.38988 21.61 6.37988C21.59 6.37988 21.57 6.39988 21.55 6.40988C20.89 6.74988 20.47 7.52988 20.47 8.66988C20.47 10.8599 22.01 13.5199 23.9 14.6099C24.83 15.1399 25.67 15.1999 26.28 14.8699C26.34 14.8399 26.4 14.7999 26.45 14.7699C26.39 14.7999 26.33 14.8199 26.26 14.8399C25.68 15.0299 24.95 14.9199 24.16 14.4599V14.4499Z",
    fill: "url(#paint12_linear_2317_204489)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66.59 26.1999C66.59 22.7099 64.14 18.4699 61.12 16.7299C59.6 15.8499 58.22 15.7799 57.22 16.3699L54.6 17.8799L55.65 19.7499C55.65 19.7499 55.65 19.8399 55.65 19.8799C55.65 23.3099 58.02 27.4699 60.98 29.2599L62.16 31.3599L64.97 29.7399C65.97 29.1699 66.59 27.9399 66.59 26.1899V26.1999Z",
    fill: "url(#paint13_linear_2317_204489)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2349 31.3382C64.3681 30.1066 64.367 26.111 62.2324 22.4138C60.0978 18.7166 56.6381 16.7178 54.5049 17.9494C52.3717 19.181 52.3729 23.1766 54.5075 26.8738C56.642 30.571 60.1017 32.5698 62.2349 31.3382Z",
    fill: "url(#paint14_linear_2317_204489)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9049 30.7666C63.8563 29.64 63.8556 25.9854 61.9033 22.6038C59.951 19.2223 56.7863 17.3944 54.8349 18.521C52.8835 19.6477 52.8842 23.3023 54.8365 26.6838C56.7888 30.0654 59.9535 31.8933 61.9049 30.7666Z",
    fill: "#EDECED"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8 30.7299C60.96 30.9999 59.89 30.8399 58.74 30.1799C55.98 28.5899 53.75 24.7199 53.75 21.5399C53.75 20.1099 54.2 19.0699 54.94 18.4899C54.97 18.4699 55 18.4499 55.02 18.4299C54.99 18.4399 54.96 18.4599 54.93 18.4799C53.97 18.9699 53.37 20.1099 53.37 21.7599C53.37 24.9399 55.6 28.8099 58.36 30.3999C59.71 31.1799 60.93 31.2699 61.83 30.7799C61.92 30.7299 62 30.6799 62.08 30.6299C61.99 30.6699 61.9 30.6999 61.81 30.7299H61.8Z",
    fill: "url(#paint15_linear_2317_204489)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M58.74 30.1799C55.98 28.5899 53.75 24.7199 53.75 21.5399C53.75 20.1099 54.2 19.0699 54.94 18.4899C54.97 18.4699 55 18.4499 55.02 18.4299C54.99 18.4399 54.96 18.4599 54.93 18.4799C53.97 18.9699 53.37 20.1099 53.37 21.7599C53.37 24.9399 55.6 28.8099 58.36 30.3999C59.71 31.1799 60.93 31.2699 61.83 30.7799C61.92 30.7299 62 30.6799 62.08 30.6299C61.99 30.6699 61.9 30.6999 61.81 30.7299C60.97 30.9999 59.9 30.8399 58.75 30.1799H58.74Z",
    fill: "url(#paint16_linear_2317_204489)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2317_204489",
    x1: 19.77,
    y1: 53.1499,
    x2: 60.96,
    y2: 76.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#171717",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#565656",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2317_204489",
    x1: 29.29,
    y1: 50.6701,
    x2: 44.51,
    y2: 24.3201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2317_204489",
    x1: 18.3418,
    y1: 40.8857,
    x2: 45.7018,
    y2: 40.8857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2317_204489",
    x1: 19.67,
    y1: 41.1801,
    x2: 41.12,
    y2: 41.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2317_204489",
    x1: 19.67,
    y1: 41.1801,
    x2: 41.12,
    y2: 41.1801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2317_204489",
    x1: 55.13,
    y1: 64.2899,
    x2: 59.39,
    y2: 56.9199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2317_204489",
    x1: 52.0641,
    y1: 61.5593,
    x2: 59.7141,
    y2: 61.5593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2317_204489",
    x1: 52.45,
    y1: 61.63,
    x2: 58.46,
    y2: 61.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2317_204489",
    x1: 52.45,
    y1: 61.63,
    x2: 58.46,
    y2: 61.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2317_204489",
    x1: 23.13,
    y1: 13.38,
    x2: 27.39,
    y2: 6.01001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2317_204489",
    x1: 20.0685,
    y1: 10.6395,
    x2: 27.7185,
    y2: 10.6395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2317_204489",
    x1: 20.47,
    y1: 10.7199,
    x2: 26.45,
    y2: 10.7199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2317_204489",
    x1: 20.47,
    y1: 10.7199,
    x2: 26.45,
    y2: 10.7199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2317_204489",
    x1: 57.28,
    y1: 28.5499,
    x2: 63.36,
    y2: 18.0199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B1B0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#A5A6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#9E9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9D9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2317_204489",
    x1: 52.9018,
    y1: 24.6472,
    x2: 63.8418,
    y2: 24.6472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9B8B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2317_204489",
    x1: 53.37,
    y1: 24.7599,
    x2: 62.07,
    y2: 24.7599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2317_204489",
    x1: 53.37,
    y1: 24.7599,
    x2: 62.07,
    y2: 24.7599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNogatewayLarge);
export default __webpack_public_path__ + "static/media/nogateway_large.7b980411342ed4a61dba72471dbd9bed.svg";
export { ForwardRef as ReactComponent };